export default "__VITE_ASSET__BOAqC4tx__"